import { useState, useEffect } from 'react';

import { useErrorHandler } from '@/shared/hooks/useErrorHandler';
import { inspectionService } from '@/services/inspection.service';
import { InspectionRequest } from '@/services/types/inspection.types';

interface UseDetailInspectionProps {
  inspectionId: string | null;
  itemId?: string | null | undefined;
  isOpen: boolean;
}

export function useDetailInspection({ inspectionId, itemId, isOpen }: UseDetailInspectionProps) {
  const [inspection, setInspection] = useState<InspectionRequest | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('info');
  const { handleError } = useErrorHandler();

  const fetchInspectionDetails = async (id: string, specificItemId?: string | null | undefined) => {
    setIsLoading(true);
    try {
      try {
        const response = await inspectionService.getInspectionRequestById(id);

        if (specificItemId && response.items) {
          const filteredItem = response.items.find((item) => item.id === specificItemId);
          if (filteredItem) {
            setInspection({
              ...response,
              items: [filteredItem],
            });
          } else {
            setInspection(response);
          }
        } else {
          setInspection(response);
        }
        return;
      } catch {
        if (specificItemId) {
          const itemResponse = await inspectionService.getInspectionItemById(specificItemId);
          if (itemResponse && itemResponse.inspectionRequestId) {
            const requestResponse = await inspectionService.getInspectionRequestById(
              itemResponse.inspectionRequestId
            );
            const filteredItem = requestResponse.items?.find((item) => item.id === specificItemId);
            setInspection({
              ...requestResponse,
              items: filteredItem ? [filteredItem] : requestResponse.items,
            });
            return;
          }
        }
        throw new Error('Inspeção não encontrada');
      }
    } catch (error) {
      handleError(error, 'Erro ao carregar detalhes da inspeção');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen && inspectionId) {
      fetchInspectionDetails(inspectionId, itemId);
    } else {
      setInspection(null);
      setActiveTab('info');
    }
  }, [isOpen, inspectionId, itemId]);

  const refreshInspection = () => {
    if (inspectionId) {
      fetchInspectionDetails(inspectionId, itemId);
    }
  };

  return {
    inspection,
    isLoading,
    activeTab,
    setActiveTab,
    refreshInspection,
  };
}
